import { Pipe, PipeTransform } from '@angular/core';
import { EditorSpecialItemType } from '../enums/editor-special-item-type-enum.service';
import { EditorColumnConfig } from '../models/editor-column-config.model';
import { EditorItemConfig } from '../models/editor-item-type';

@Pipe({
  name: 'editorColumns',
})
export class EditorColumnsPipe implements PipeTransform {
  transform(items: EditorItemConfig[] | EditorColumnConfig[]): EditorColumnConfig[] {
    if (!items || !items.length) {
      return [];
    }

    const [firstItem]: EditorItemConfig[] | EditorColumnConfig[] = items;
    if (firstItem.type === EditorSpecialItemType.Column) {
      return items as EditorColumnConfig[];
    } else {
      return [
        {
          type: EditorSpecialItemType.Column,
          width: '100%',
          items: items as EditorItemConfig[],
        },
      ];
    }
  }
}
